<template>
     <div class="home">
        <UserPassword/>
   </div> 
</template>

<script>
import UserPassword from '@/components/DPEBB/Administrator/UserPassword.vue'
import LayoutDefault from '../../Common/Default/DefaultLayout.vue';
export default {
 data: function () {
    return {  
            AppServiceID :6,
            minPassword: 0}
      },
      methods:{
            Go(){
            this.$router.push('/DPEBB/Home')
        },
      },
       components: { 
            UserPassword
        }
        ,
     created: function() {
            this.$emit('update:layout', LayoutDefault);
    },
    beforeCreate: function() {
        
        console.log('At Manage User Before created')
         this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
            //this.$store.dispatch('SetBuildMenu');
    },
}
</script>

<style>

</style>
